export const FETCH_FEED = 'FETCH_FEED';
export const FETCH_FEED_SUCCESS = 'FETCH_FEED_SUCCESS';
export const FETCH_FEED_FAIL = 'FETCH_FEED_FAIL';
export const FETCH_QUERY = 'FETCH_QUERY';
export const FETCH_QUERY_SECCESS = 'FETCH_QUERY_SECCESS';
export const FETCH_QUERY_FAIL = 'FETCH_QUERY_FAIL';

export const fetchQuery = (query) => ({
  type: FETCH_QUERY,
  query
})

export const fetchQuerySuccess = () => ({
  type: FETCH_QUERY_SECCESS
})

export const fetchQueryFail = () => ({
  type: FETCH_QUERY_FAIL
})

export const fetchFeed = ({query, isAppend}) => ({
  type: FETCH_FEED,
  query,
  isAppend,
});

export const fetchFeedSuccess = ({data, count, isAppend}) => ({
  type: FETCH_FEED_SUCCESS,
  data,
  count,
  isAppend,
});

export const fetchFeedFail = (error) => ({
  type: FETCH_FEED_FAIL,
  error: error
});



/** WEBPACK FOOTER **
 ** ./src/app/modules/feed/actions.js
 **/